module.exports = __webpack_public_path__ + "fonts/MyriadPro-Regular.46a2210.woff";